/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { createCloseEvent } from './create-close-event';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { Dialog } from './dialog-content';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { TDialogCloseReason, TDialogDismissedBy, TDialogProps } from './types';
